import { useQuery } from '@tanstack/react-query';
import { QUERY_CACHE_CONFIG } from 'configs/queryCache';
import { ProvincesService } from 'services/openapi';
import { ProvincesQueryKeys } from './constants';

export const useGetAllDevisionsQuery = (variables?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: [ProvincesQueryKeys.GET_ALL_DEVISIONS],
    queryFn: () => ProvincesService.provincesControllerGetAllDevisions(),
    enabled: variables?.enabled ?? true,
    ...QUERY_CACHE_CONFIG.REFERENCE_DATA,
    refetchOnWindowFocus: false,
  });
};
